export default "__VITE_ASSET__CGbiL3tE__"